import {Observable} from 'rxjs';
import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {
    BillingTextTemplateBundleRes,
    BillingTextTemplateRes,
    BillingTextTemplateSaveReq,
    BillingTextTemplateSearchReq,
} from '../../../../contracts/v0/cp/billing-text-template.contract';

export class ApiV0BillingTextTemplate {
    private readonly segment: string;

    constructor(v0: ApiV0, private readonly rest: RestApiService) {
        this.segment = `${v0.segment}/BillingTextTemplate`;
    }

    resolve(req: BillingTextTemplateSearchReq): Observable<BillingTextTemplateBundleRes> {
        return this.rest.post<BillingTextTemplateSearchReq, BillingTextTemplateBundleRes>(
            `${this.segment}/Resolve`, BillingTextTemplateBundleRes, req,
        );
    }

    list(): Observable<BillingTextTemplateRes[]> {
        return this.rest.get<BillingTextTemplateRes[]>(this.segment, BillingTextTemplateRes);
    }

    save(req: BillingTextTemplateSaveReq): Observable<BillingTextTemplateRes> {
        return this.rest.post<BillingTextTemplateSaveReq, BillingTextTemplateRes>(
            this.segment, BillingTextTemplateRes, req,
        );
    }

    update(id: number, req: BillingTextTemplateSaveReq): Observable<BillingTextTemplateRes> {
        return this.rest.patch<BillingTextTemplateSaveReq, BillingTextTemplateRes>(
            `${this.segment}/${id}`, BillingTextTemplateRes, req,
        );
    }

    delete(id: number): Observable<void> {
        return this.rest.delete<void>(`${this.segment}/${id}`);
    }
}
